export function getBootstrapped(state) {
    return state.bootstrapped
}
export function getHorizon(state, key) {
    return state[key].horizon
}

export function getTeamDashboardId(state) {
    return state.viewport.teamId
}

export function getProfileId(state) {
    return state.profile.id
}

export function getState(state) {
    return state
}

export function getProfile(state) {
    return state.profile
}

export function getNavigation(state) {
    return state.navigation
}

export function getPersonalTeamId(state) {
    return state.profile.personalTeamId
}

export function getTeam(state, teamId) {
    return state.teams.items[teamId]
}

export function getGoals(state) {
    const goals = state.goals.items
    return goals
        ? goals
        : undefined
}

export function getRunningTimeEntryIds(state, userId) {
    const userTimeEntryIds = state.runningTimeEntries[userId]
    return userTimeEntryIds
        ? userTimeEntryIds
        : []
}

export function getRunningTimeEntries(state, userId) {
    const ids = getRunningTimeEntryIds(state, userId)
    const entries = ids.map(id => {
        const entry = state.timeEntries.items[id]
        return entry && entry
    })
    return entries.filter(entry => !!entry)
}

export function getMyRunningTimeEntries(state) {
    const userId = getProfileId(state)
    return getRunningTimeEntries(state, userId)
}

export function getCurrentInterval(state) {

    const { interval }  = state.viewport.range
    return interval
}

export function getCurrentIncrement(state) {
    const { increment }  = state.viewport.range
    return increment
}

export function getCurrentRange(state) {
    return state.viewport.range
}

export function getSelectedTeamMembership(state) {
    return state.selectedTeamMembership
}

export function getCustomer(state) {
    return state.customer
}

export function getSelectedTeamInvites(state) {
    return state.selectedTeamInvites
}

export function getUI(state) {
    return state.ui
}

export function getAccount(state, accountId) {
    return state.accounts.items[accountId]
}


// WEBPACK FOOTER //
// ./src/redux/selectors.js